<app-dashboard-option [categories]="['CELL']" [label]="'TO_DISPLAY'">
  <div app-dashboard-option-content>
    <app-check [color]="color" [value]="cell.display" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-dashboard-option>